import LinkButton from "@/components/common/Buttons/LinkButton"
import { getLinkData } from "@/components/common/Links/utils"
import { BUTTON_VARIANTS } from "@/constants"

export default function Button({ data }) {
	const buttonData = getLinkData(data?.link || {})
	return <LinkButton {...buttonData} variant={BUTTON_VARIANTS.SECONDARY} />
}
